var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryBooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3584 11.8043L14.0888 14.6625L11.8045 15.4392L2.54059 12.2024L11.8028 15.6501V15.6509H11.8037L14.3396 14.7238L14.6296 14.7941L11.8102 15.9134L2.3584 12.2907V11.8043Z",
    fill: "#3D5FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.664918 11.0218L1.71394 10.6981L1.71475 11.0562L14.8234 14.1245C15.2254 13.4402 15.2393 12.4011 15.0734 11.6211L24.1878 6.45978C24.5211 7.26427 24.8512 8.3778 24.1592 9.61561C21.1355 11.4372 17.4435 13.5898 15.4517 14.7467C15.3087 14.8301 15.151 14.8146 14.9754 14.7712L11.0734 13.7967L0.654297 11.335L0.665735 11.0218H0.664918Z",
    fill: "#3D5FC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3813 13.2252L19.3331 12.6684L24.4483 10.7005L24.4508 10.8632L18.3813 13.2252ZM20.2776 12.1125L23.4728 10.2043L24.3862 10.5501L20.2784 12.1125H20.2776Z",
    fill: "#3D5FC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.686035 8.04178L11.8168 5.2236L23.9295 6.41971L14.8911 11.5385L0.686035 8.52823V8.04178Z",
    fill: "#3D5FC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.90012 8.87079L2.06434 8.90267L2.0578 10.9703L1.88623 10.9303L1.90012 8.87079Z",
    fill: "#3D5FC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8416 11.8795L14.8685 12.0446L2.11035 9.31964L2.11117 9.17493L14.8416 11.8795Z",
    fill: "#3D5FC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.896 12.3782L14.9009 12.5482L2.11084 9.80365L2.11166 9.65976L14.896 12.3782Z",
    fill: "#3D5FC0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8783 12.8851L14.8661 13.0429L2.11035 10.25L2.11117 10.1094L14.8783 12.8851Z",
    fill: "#3D5FC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8118 13.4149L14.7742 13.5751L2.11166 10.7177L2.11084 10.5664L14.8118 13.4149Z",
    fill: "#3D5FC0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22942 11.8721C1.35769 12.3684 1.64772 14.5864 1.94184 15.0394C2.23596 15.4907 11.8324 19.7625 11.8324 19.7625C12.9664 19.2049 24.5342 13.7869 24.5366 13.6773C24.5366 13.6773 24.5309 13.3674 24.5325 13.2881L23.9794 13.2824C23.1763 13.6838 11.8087 19.1011 11.7891 19.0471C11.7891 19.0471 3.6657 15.274 2.54151 14.7352C2.36096 14.6486 2.03906 13.4933 2.3871 12.4174L2.25148 12.3659C2.25148 12.3659 2.24821 11.8631 2.22942 11.8729V11.8721Z",
    fill: "#3D5FC0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6664 11.2418L23.8339 11.1764C23.7334 11.837 23.7415 12.5989 23.8347 13.235L23.6941 13.3086C23.5896 12.5523 23.5847 11.8051 23.6664 11.2418Z",
    fill: "#3D5FC0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7247 18.4756L11.7239 18.6424L2.61359 14.5946C2.5711 14.5243 2.54333 14.4344 2.53516 14.387L11.7255 18.4756H11.7247Z",
    fill: "#3D5FC0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7278 17.8101L11.7269 17.9769L2.48839 13.9683C2.47041 13.9389 2.46143 13.8621 2.46143 13.8081L11.7278 17.8109V17.8101Z",
    fill: "#3D5FC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7318 17.152L11.7302 17.3188L2.46545 13.4198C2.45646 13.3519 2.45483 13.2947 2.46872 13.2358L11.731 17.152H11.7318Z",
    fill: "#3D5FC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7353 16.4096L11.7345 16.5756L2.49268 12.8687L2.52127 12.7159L11.7353 16.4096Z",
    fill: "#3D5FC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.897 18.4895V18.6481L23.5898 13.1982L23.5718 13.0478L11.897 18.4895Z",
    fill: "#3D5FC0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8984 17.8183V17.9769L23.5357 12.6488L23.5292 12.5065L11.8984 17.8183Z",
    fill: "#3D5FC0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9017 16.4145L11.9009 16.5772L23.5022 11.6424L23.5193 11.4682C19.5528 13.1287 15.8257 14.7361 11.9009 16.4137L11.9017 16.4145Z",
    fill: "#3D5FC0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8994 17.161L11.9002 17.3196L23.495 12.1705L23.4983 11.9955L11.8994 17.161Z",
    fill: "#3D5FC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBooks);
export default __webpack_public_path__ + "static/media/category-books.095f18f0972844d8b419c669faab1839.svg";
export { ForwardRef as ReactComponent };